define('common/dateUtil',["require", "exports"], function (require, exports) {
    "use strict";
    var Date;
    (function (Date) {
        function getLocalTime(date) {
            return moment.utc(date).local();
        }
        Date.getLocalTime = getLocalTime;
    })(Date || (Date = {}));
    return Date;
});

